import { useState } from "react";
import { Link } from "react-router-dom";
import { FiHeart, FiShoppingCart } from "react-icons/fi";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import "./ProductCard.css";

export default function ProductCard({ product }) {
  const { dispatch } = useCart();
  const { toggle, isWished } = useWishlist();
  const [added, setAdded] = useState(false);
  const wished = isWished(product.id);

  const handleAdd = (e) => {
    e.preventDefault();
    dispatch({ type: "ADD", item: { ...product, size: product.sizes?.[0] || "", color: product.colors?.[0] || "" } });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  const discount = product.originalPrice
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : null;

  return (
    <Link to={`/product/${product.id}`} className="product-card">
      <div className="product-img-wrap">
        <img src={product.image} alt={product.name} loading="lazy" />
        {product.badge && <span className={`badge badge-${product.badge.toLowerCase()}`}>{product.badge}</span>}
        {discount && <span className="badge badge-discount">-{discount}%</span>}
        <button className={`wish-btn ${wished ? "wished" : ""}`} onClick={e => { e.preventDefault(); toggle(product); }}>
          <FiHeart />
        </button>
      </div>
      <div className="product-info">
        <h3>{product.name}</h3>
        <div className="product-rating">
          {[...Array(5)].map((_, i) => (
            <span key={i} className={`star ${i < Math.floor(product.rating) ? "filled" : ""}`}>★</span>
          ))}
          <span className="reviews">({product.reviews})</span>
        </div>
        <div className="product-price">
          <span className="price">Rs. {product.price.toLocaleString()}</span>
          {product.originalPrice && <span className="original">Rs. {product.originalPrice.toLocaleString()}</span>}
        </div>
        <div className="color-dots">
          {product.colors.slice(0, 3).map(c => <span key={c} className="color-dot" title={c} />)}
        </div>
        <button className={`add-cart-btn ${added ? "added" : ""}`} onClick={handleAdd}>
          <FiShoppingCart /> {added ? "Added!" : "Add to Cart"}
        </button>
      </div>
    </Link>
  );
}
